import './SearchResult.css';
import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import RecipeCard from '../components/RecipeCard';
import Header from '../components/Header';
import SortDropdown from '../components/SortDropdown';

const baseURL = process.env.REACT_APP_API_URL;


function SearchResultsPage() {
    const [params, setParams] = useSearchParams();
    const query = params.get('q') || '';
    const [sortOption, setSortOption] = useState('recent');
    const [results, setResults] = useState([]);

    
    useEffect(() => {
        const fetchResults = async () => {
            try {
                const res = await fetch(`${baseURL}/recipes/search?q=${query}&sort=${sortOption}`);
                const data = await res.json();

                if (Array.isArray(data)) {
                    setResults(data);
                } else {
                    console.warn("Unexpected search response:", data);
                    setResults([]);
                }
            } catch (err) {
                console.error('Search failed:', err);
                setResults([]);
            }
        };

        if (query) fetchResults();
    }, [query, sortOption]);

    return (
        <>
            <Header />
            <div>
                <h2 className="search-container">Search Results for "{query}"</h2>
                <div className="search-header">
                    <SortDropdown
                        value={sortOption}
                        onChange={(e) => {
                            const newSort = e.target.value;
                            setSortOption(newSort);
                            setParams({ q: query, sort: newSort });
                        }}
                    />
                </div>

                <div className="recipe-grid">
                    {results.map(recipe => (
                        <RecipeCard key={recipe._id} recipe={{ ...recipe, image: recipe.image }} />
                    ))}
                </div>
            </div>
        </>
    );
}

export default SearchResultsPage;